import {FC} from "react";
import {BaseIcon, IPropsIcon} from "./BaseIcon";

interface IProps extends IPropsIcon {

}

export const FilterIcon: FC<IProps> = ({size = 15, fill = 'none'}) => {
    return (
        <BaseIcon size={size} viewBox="0 0 16 16" fill={fill}>
            <path
                d="M14.0234 0.799561H1.80078C1.00781 0.799561 0.625 1.75659 1.17188 2.30347L6.17578 7.30737V12.3933C6.17578 12.6667 6.28516 12.9128 6.44922 13.0769L8.19922 14.6082C8.77344 15.073 9.67578 14.6902 9.67578 13.9246V7.30737L14.6523 2.30347C15.1992 1.75659 14.8164 0.799561 14.0234 0.799561ZM8.80078 6.92456V13.9246L7.05078 12.3933V6.92456L1.80078 1.67456H14.0508L8.80078 6.92456Z"
                fill="#0D0D0E"
            />
        </BaseIcon>
    )
}
